/* src/app/shared/components/toast/toast.component.scss */
.device-desktop {
  min-width: 1280px;
  overflow-x: auto;
}
.device-tablet {
  min-width: 1133px;
  overflow-x: auto;
}
.device-mobile {
  min-width: 390px;
  overflow-x: auto;
}
.header-h1 {
  font-family: var(--font-family) !important;
  font-weight: 300 !important;
  font-size: 2rem !important;
  color: var(--color-header-name) !important;
}
.header-h2 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 1.875rem !important;
  color: var(--color-header-name) !important;
}
.header-h3 {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1.5rem !important;
  color: var(--color-header-name) !important;
}
.header-h4 {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1.125rem !important;
  color: var(--color-header-name) !important;
}
.header-h5 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
  color: var(--color-header-name) !important;
}
.header-h6 {
  font-family: var(--font-family) !important;
  font-weight: 700 !important;
  font-size: 0.8125rem !important;
  color: var(--color-header-name) !important;
}
.body-text {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: var(--color-header-name) !important;
}
.small-body-text {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 11.375px !important;
  color: var(--color-header-name) !important;
}
.text-link {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 1rem !important;
  color: var(--color-secondary) !important;
  text-decoration: underline;
}
.text-link:hover {
  color: var(--color-hover) !important;
}
.text-link:visited {
  color: var(--color-visited) !important;
}
.small-text-link {
  font-family: var(--font-family) !important;
  font-weight: 400 !important;
  font-size: 0.8125rem !important;
  color: var(--color-secondary) !important;
  text-decoration: underline;
}
.small-text-link:hover {
  color: var(--color-hover) !important;
}
.small-text-link:visited {
  color: var(--color-visited) !important;
}
.toast .inline-message .inline-message-content .description,
.toast .inline-message .inline-message-content .note,
.toast .inline-message .inline-message-content .title {
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 400;
  color: var(--color-black);
  line-height: 22px;
  letter-spacing: 0px;
}
.toast .inline-message .inline-message-content .title {
  font-weight: 600;
}
.toast {
  position: fixed;
  top: 75px;
  right: 20px;
  border-radius: 10px;
  z-index: 1000;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  width: 40%;
}
.toast .inline-message {
  display: flex;
  align-items: flex-start;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.0509803922);
}
.toast .inline-message .inline-message-icon {
  font-size: 24px;
  margin-right: 1rem;
  flex-shrink: 0;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.toast .inline-message .inline-message-content {
  flex-grow: 1;
}
.toast .inline-message .inline-message-content .title {
  line-height: 20px;
  margin-bottom: 0.25rem;
  text-transform: capitalize;
}
.toast .inline-message .inline-message-content .description,
.toast .inline-message .inline-message-content .note {
  line-height: 20px;
  color: var(--color-info-description);
  word-break: break-word;
}
.toast .inline-message .inline-message-close-icon {
  font-size: 16px;
  cursor: pointer;
  color: #667085;
  margin-left: -10px;
  flex-shrink: 0;
}
.toast .inline-message.info {
  background-color: var(--color-info-bg);
  color: var(--color-royal-purple);
  border: 1px solid var(--color-royal-purple);
  border-bottom-width: 4px;
}
.toast .inline-message.error {
  background-color: var(--color-inline-error-bg);
  color: var(--color-info-error);
  border: 1px solid var(--color-info-error);
  border-bottom-width: 4px;
}
.toast .inline-message.warning {
  background-color: var(--color-inline-warning-bg);
  color: var(--color-info-warning);
  border: 1px solid var(--color-info-warning);
  border-bottom-width: 4px;
}
.toast .inline-message.success {
  background-color: var(--color-inline-success-bg);
  color: var(--color-info-success);
  border: 1px solid var(--color-info-success);
  border-bottom-width: 4px;
}
.toast .inline-message.info .inline-message-content .title {
  color: var(--color-info-title);
}
.toast .inline-message.error .inline-message-content .title {
  color: var(--color-info-error);
}
.toast .inline-message.warning .inline-message-content .title {
  color: var(--color-info-warning);
}
.toast .inline-message.success .inline-message-content .title {
  color: var(--color-info-success);
}
:host-context(.device-tablet) .toast .inline-message {
  flex-direction: row;
  padding: 0.75rem;
}
:host-context(.device-tablet) .toast .inline-message .inline-message-icon {
  font-size: 20px;
  margin-right: 0.75rem;
}
:host-context(.device-mobile) .toast .inline-message {
  align-items: flex-start;
  padding: 0.75rem;
}
:host-context(.device-mobile) .toast .inline-message .inline-message-icon {
  font-size: 20px;
  margin-right: 10px;
  margin-bottom: 0.5rem;
}
/*# sourceMappingURL=toast.component.css.map */
